module.exports = __webpack_public_path__ + "static/img/X10显控终端.0b3b3ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD300/X10显控终端.png
// module id = 5b7b
// module chunks = 0